import { IConsumerChannelsConfigCrumbs } from '../types';

export enum CONSUMER_CHANNEL_CONFIG_CRUMB {
  COLORS = 'colors_tab',
  LAYOUT = 'layout_tab',
  IMAGES = 'images_tab',
  CONFIGURATION = 'configuration_tab',
}

export enum CONSUMER_CHANNEL_CONFIGURATION_SCREEN {
  MOBILE = 'mobile',
  WEB = 'web',
  KIOSK = 'kiosk',
}

export const defaultConsumerChannelsConfigNavigationCrumbs: IConsumerChannelsConfigCrumbs = {
  mobile: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS,
  web: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS,
  kiosk: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS,
};

export const COLOR_ELEMENT_IDENTIFIER = {
  INPUT: 'color-input',
  BOX: 'color-box',
  HEX_PICKER: 'color-hex-picker',
  CLASS_NAME: 'colorful',
};
